import React from "react";
import { Navigate } from "react-router-dom";

const Authmiddleware = (props) => {
  
  if (!localStorage.getItem("authUser") || (localStorage.getItem("user_type") != props?.role && typeof props?.role != 'undefined') ) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
